<div class="feature-management-header">
    <h2>Administration JFSE</h2>
</div>
<mat-card>
    <form [formGroup]="form" class="form-fields">
        <mat-form-field appearance="fill">
          <mat-label>ID JFSE</mat-label>
          <input matInput formControlName="idJfse" type="number" placeholder="Entrez l'ID JFSE">
        </mat-form-field>
    
        <mat-form-field appearance="fill">
          <mat-label>ID Lecteur</mat-label>
          <input matInput formControlName="idLecteur" placeholder="Entrez l'ID Lecteur">
        </mat-form-field>

        <div class="tiles">
            <button mat-raised-button (click)="manageEtablissement()">
              Gestion Établissement
            </button>
            <button mat-raised-button (click)="manageUtilisateur()">
              Gestion Utilisateur
            </button>
            <button mat-raised-button (click)="manageParamAdmin()">
              Paramétrage
            </button>
            <button mat-raised-button (click)="manageLOT()" matTooltip="idJFSE et idLecteur requis">
              Déformatage Lot
            </button>
          </div>
    </form>

    <div class="iframe-container" *ngIf="iframeUrl">
        <iframe *ngIf="iframeUrl" [src]="iframeUrl" id="main-iframe" frameborder="0"></iframe>
    </div>
  </mat-card>
  